module.exports = "<section class=\"dd-section dd-credits\"><div class=container><div class=article-container><div class=article-content data-ng-bind-html=post.translations[$root.lang].credits></div></div></div><div class=close data-ng-click=\"toggleDd('credits')\"></div></section>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-players/nn-dropdown-credits/nn-dropdown-credits.directive.html
// module id = 1038
// module chunks = 0